import {
  QUESTION_SINGLE,
  QUESTION_MULTIPLE,
  QUESTION_DESCRIPTION,
  QUESTION_RATING,
  QUESTION_SLIDER,
  QUESTION_OPEN_ENDED,
  QUESTION_NUMERICAL_OPEN_ENDED,
  QUESTION_RANKING,
  QUESTION_MATRIX_SINGLE,
  QUESTION_MATRIX_MULTIPLE,
  QUESTION_MATRIX_VAN_WESTENDORP,
  QUESTION_MATRIX_MAXDIFF,
  ANSWER_OTHER,
  ANSWER_NONE_OF_THE_ABOVE,
} from '../../constants';
import {
  getGenericShuffleType,
  getShuffledAndCarriedForwardAnswers,
} from '../../utils';
import { carryForwardService } from '../../logic';

export const getAnswerClass = ({
  question,
  answer = {},
  containsOnlyEmoji,
}) => {
  let answerClass = '';

  switch (question.style) {
    case QUESTION_MULTIPLE:
    case QUESTION_MATRIX_MAXDIFF:
      answerClass = 'multi-choice';
      break;
    case QUESTION_DESCRIPTION:
    case QUESTION_RATING:
    case QUESTION_SLIDER:
    case QUESTION_OPEN_ENDED:
    case QUESTION_NUMERICAL_OPEN_ENDED:
      answerClass = 'hidden';
      break;
    case QUESTION_RANKING:
    case QUESTION_MATRIX_SINGLE:
    case QUESTION_MATRIX_MULTIPLE:
    case QUESTION_MATRIX_VAN_WESTENDORP:
      answerClass = 'multi-choice hidden';
      break;
    default:
      answerClass = 'single-choice';
  }

  if (answer.style === ANSWER_NONE_OF_THE_ABOVE) {
    answerClass =
      question.style === QUESTION_SINGLE ? 'single-choice' : 'multi-choice';
    answerClass += ' none-of-the-above';
  }

  if (answer.style === ANSWER_OTHER) {
    answerClass += ' answer-other';
  }

  if (containsOnlyEmoji) {
    answerClass += ' contains-only-emoji';
  }

  if (answer.isExclusive === true) {
    answerClass += ' exclusive-answer';
  }

  return `answer--${answerClass}`;
};

export function shuffleAnswers(node) {
  return getShuffledAndCarriedForwardAnswers(
    node,
    [...Pollfish.screening.getQuestions(), ...Pollfish.survey.props.questions],
    Pollfish.store.getRespondentKnowledge(),
    carryForwardService,
  );
}

export { getGenericShuffleType };
